var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#AD0606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9759 11.77H7.0159L6.7659 6.86H8.2259L7.9759 11.77ZM6.7259 13.36C6.7259 13.08 6.79923 12.8833 6.9459 12.77C7.09257 12.65 7.2759 12.59 7.4959 12.59C7.70257 12.59 7.87923 12.6467 8.0259 12.76C8.17923 12.8733 8.2559 13.0733 8.2559 13.36C8.2559 13.6333 8.17923 13.83 8.0259 13.95C7.87923 14.07 7.70257 14.13 7.4959 14.13C7.2759 14.13 7.09257 14.07 6.9459 13.95C6.79923 13.83 6.7259 13.6333 6.7259 13.36ZM10.4786 11.77H9.51863L9.26863 6.86H10.7286L10.4786 11.77ZM9.22863 13.36C9.22863 13.08 9.30197 12.8833 9.44863 12.77C9.5953 12.65 9.77863 12.59 9.99863 12.59C10.2053 12.59 10.382 12.6467 10.5286 12.76C10.682 12.8733 10.7586 13.0733 10.7586 13.36C10.7586 13.6333 10.682 13.83 10.5286 13.95C10.382 14.07 10.2053 14.13 9.99863 14.13C9.77863 14.13 9.5953 14.07 9.44863 13.95C9.30197 13.83 9.22863 13.6333 9.22863 13.36ZM12.9814 11.77H12.0214L11.7714 6.86H13.2314L12.9814 11.77ZM11.7314 13.36C11.7314 13.08 11.8047 12.8833 11.9514 12.77C12.098 12.65 12.2814 12.59 12.5014 12.59C12.708 12.59 12.8847 12.6467 13.0314 12.76C13.1847 12.8733 13.2614 13.0733 13.2614 13.36C13.2614 13.6333 13.1847 13.83 13.0314 13.95C12.8847 14.07 12.708 14.13 12.5014 14.13C12.2814 14.13 12.098 14.07 11.9514 13.95C11.8047 13.83 11.7314 13.6333 11.7314 13.36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHigh);
export default __webpack_public_path__ + "static/media/priority-high.3ef922ae30fb117652210ccd1be162ac.svg";
export { ForwardRef as ReactComponent };